import React from "react";
import DataTable from "../../components/DataTable";
import SectionCommonTable from "../../components/SectionCommonTable";

const dataJson = [
  {
    sn: "01",
    date: "09/03/2022",
    orderId: "mono12345",
    txnId: "erfsfsuejjrf",
    amount: "$75",
    paymentMode: "Bitcoin",
    amountTrx: "630",
    status: "completed",
  },
  {
    sn: "02",
    date: "09/03/2022",
    orderId: "mono12345",
    txnId: "erfsfsuejjrf",
    amount: "$75",
    paymentMode: "Bitcoin",
    amountTrx: "630",
    status: "pending",
  },
  {
    sn: "03",
    date: "09/03/2022",
    orderId: "mono12345",
    txnId: "erfsfsuejjrf",
    amount: "$75",
    paymentMode: "Bitcoin",
    amountTrx: "630",
    status: "processing",
  },
];

const columns = [
  { id: "sn", label: "S.N", minWidth: 50 },
  { id: "date", label: "Date", minWidth: 100 },
  {
    id: "orderid",
    label: "Order ID",
    minWidth: 100,
  },
  {
    id: "txnid",
    label: "Txn ID",
    minWidth: 100,
  },
  {
    id: "amount",
    label: "Amount",
    minWidth: 100,
  },
  {
    id: "paymentMode",
    label: "Payment Mode",
    minWidth: 100,
  },
  {
    id: "amountTrx",
    label: "Amount TRX",
    minWidth: 100,
  },
  {
    id: "status",
    label: "Status",
    minWidth: 100,
  },
];

function createData(
  sn,
  date,
  orderid,
  txnid,
  amount,
  paymentMode,
  amountTrx,
  status
) {
  return { sn, date, orderid, txnid, amount, paymentMode, amountTrx, status };
}

const rows = dataJson.map((d) =>
  createData(
    d.sn,
    d.date,
    d.orderId,
    d.txnId,
    d.amount,
    d.paymentMode,
    d.amountTrx,
    d.status
  )
);

const TransactionHistoryPage = () => {
  return (
    <SectionCommonTable
      wrapperClassName="trans_history_table"
      cardStyle={{ backgroundColor: "#fff" }}
      sectionTableTitle="transaction history"
      table={
        <DataTable
          columns={columns}
          rows={rows}
          perPageShow={10}
          tableHeight={440}
          className="common_table"
        />
      }
    />
  );
};

export default TransactionHistoryPage;
